// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `img {
  max-width: 100%;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.dir-col {
  flex-direction: column;
}

.dir-col-rev {
  flex-direction: column-reverse;
}

.mh-full {
  min-height: 100%;
}

.mt-auto {
  margin-top: auto;
}

.bt-0 {
  border-top: 0;
}

.bb-0 {
  border-bottom: 0;
}

.fn-body h1,
.fn-body h2,
.fn-body h3,
.fn-body h4,
.fn-body h5,
.fn-body h6 {
  --hGap: 10px;
  font-family: "Museo-700";
  color: #6d6e71;
  margin-bottom: var(--hGap);
  margin-top: 0;
}
.fn-body h1:last-child,
.fn-body h2:last-child,
.fn-body h3:last-child,
.fn-body h4:last-child,
.fn-body h5:last-child,
.fn-body h6:last-child {
  margin-bottom: 0;
}
.fn-body h1,
.fn-body .h1-text {
  font-size: 44px;
  line-height: 1.1;
}
@media only screen and (max-width: 767px) {
  .fn-body h1,
  .fn-body .h1-text {
    font-size: 38px;
  }
}
.fn-body h2,
.fn-body .h2-text {
  font-size: 38px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h2,
  .fn-body .h2-text {
    font-size: 32px;
  }
}
.fn-body h3,
.fn-body .h3-text {
  font-size: 32px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h3,
  .fn-body .h3-text {
    font-size: 24px;
  }
}
.fn-body h4,
.fn-body .h4-text {
  font-size: 24px;
  line-height: 1.2;
}
.fn-body h5,
.fn-body .h5-text {
  font-size: 18px;
  line-height: 1.2;
}
.fn-body h6,
.fn-body .h6-text {
  font-size: 16px;
  line-height: 1.3;
}
.fn-body p {
  font-size: 18px;
  line-height: 1.6;
  color: #6a6a6a;
  margin-top: 0;
  margin-bottom: 10px;
}
.fn-body p:last-child {
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .fn-body p {
    font-size: 16px;
  }
}
.fn-body ul,
.fn-body ol {
  padding: 0;
  margin: 0;
}
.fn-body sup {
  font-size: 0.7em;
  position: relative;
  top: 5px;
  display: inline-block;
  vertical-align: top;
}

.bg-grey {
  background-color: #eee;
}

.fn-container {
  max-width: 1080px;
  width: calc(100% - 30px);
  margin-inline: auto;
}
@media only screen and (min-width: 992px) {
  .fn-container {
    margin-left: 0;
  }
}
.fn-container--fluid {
  max-width: 1200px;
}
.fn-container--small {
  max-width: 820px;
  width: 100%;
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}

.d-none {
  display: none;
}

.section-title {
  text-align: center;
}
.section-title:not(:last-child) {
  margin-bottom: 40px;
}
.section-title h2:not(:last-child) {
  margin-block-end: 20px;
}
.section-title p {
  max-width: 900px;
  width: 100%;
  margin-inline: auto;
  font-size: 22px;
}
.section-title p:not(:last-child) {
  margin-block-end: 20px;
}
@media only screen and (max-width: 767px) {
  .section-title p {
    font-size: 18px;
  }
}
.section-title .section-title__linkcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.section-title .section-title__linkcontainer:not(:last-child) {
  margin-block-end: 20px;
}
.section-title .section-title__linkcontainer > * {
  margin: 5px;
}
.section-title .section-title__linkcontainer .fn-btn {
  padding-block: 6px;
  padding-inline: 13px;
  font-size: 12px;
  font-family: "MuseoSans-300";
}

.section-padding {
  padding-block: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding {
    padding-block: 40px;
  }
}
.section-padding-small {
  padding-block: 30px;
}
.section-padding-all {
  padding: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding-all {
    padding: 30px;
  }
}
.section-padding-all-small {
  padding: 30px;
}

.headline {
  --lineSize: 10px;
  width: -moz-fit-content;
  width: fit-content;
  padding-block-end: calc(10px + var(--lineSize));
  margin-inline: auto;
  position: relative;
}
.headline--small-border {
  --lineSize: 6px;
}
.headline:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
.headline::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--lineSize);
  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);
}

.custom-list li {
  font-size: 18px;
  line-height: 1.4;
  color: #6a6a6a;
  list-style: none;
  position: relative;
  padding-left: 15px;
}
.custom-list li:not(:last-child) {
  margin-bottom: 4px;
}
.custom-list li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 3px;
  height: 3px;
  background-color: var(--clrProfile);
}

.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.fn-btn {
  padding-block: 20px;
  padding-inline: 28px;
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-size: 18px;
  line-height: 1.2;
  display: inline-block;
  font-family: "Museo-700";
  text-decoration: none;
  word-break: break-all;
  text-align: center;
  transition: background-color 0.3s;
}
.fn-btn:focus {
  outline: 1px dashed #6a6a6a;
  outline-offset: 4px;
}
.fn-btn:hover {
  background-color: #6d6e71;
  color: #fff;
}
.fn-btn--sm {
  font-size: 14px;
  padding-block: 10px;
  padding-inline: 20px;
}
.fn-btn--grey {
  background-color: #f1f1f2;
  color: #6d6e71;
}
.fn-btn--ongoing {
  background-color: #f8ac59;
  color: #fff;
}
.fn-btn--ongoing i {
  animation: spin 0.3s infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.w-4 {
  width: 33.3333333333%;
}

.w-3 {
  width: 25%;
}
.w-3--wd {
  width: 33.3333333333%;
}

.w-6 {
  width: 50%;
}

.fn-row {
  --rGap: 15px;
  --rGap-minus: calc(-1 * var(--rGap));
  display: flex;
  flex-wrap: wrap;
  margin-inline: var(--rGap-minus);
}
.fn-row--col-gap-exist .fn-col {
  margin-bottom: 30px;
}
.fn-col {
  padding-inline: var(--rGap);
}
.fn-justify-center {
  justify-content: center;
}
.fn-items-center {
  align-items: center;
}

.mx-auto {
  margin-inline: auto;
}
.ml-auto {
  margin-inline-start: auto;
}
.ml-0 {
  margin-inline-start: 0;
}
.mr-auto {
  margin-inline-end: auto;
}
.mr-0 {
  margin-inline-end: 0;
}

.tooltippopup {
  max-width: 360px;
  width: 100%;
  height: 100%;
  background: #fff;
  position: fixed;
  top: 0;
  right: -400px;
  padding: 45px 24px 24px;
  text-align: left;
  z-index: 9999;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.05);
  transition: all ease 0.3s;
  overflow-y: auto;
}
.tooltippopup--active {
  right: 0;
}
.tooltippopup--videoexist {
  max-width: 735px;
}
.tooltippopup__btn {
  display: flex;
  flex-wrap: wrap;
  padding: 0;
  margin: 0 0 10px;
}
.tooltippopup__btn li {
  list-style: none;
  text-align: center;
  cursor: pointer;
  width: 33.3333333333%;
}
.tooltippopup__btn li button {
  width: 100%;
  color: rgb(0, 173, 208);
  font-size: 12px;
  padding: 6px 16px;
  font-family: "Museo-700" !important;
  font-weight: normal !important;
  display: inline-block;
  height: 100%;
  border: 0;
  border: 1px solid rgb(0, 173, 208);
  background-color: transparent;
  transition: all ease 0.3s;
  appearance: none;
}
.tooltippopup__btn li button.ideate {
  color: rgb(255, 121, 0);
  border-color: rgb(255, 121, 0);
}
.tooltippopup__btn li button.develop {
  color: rgb(105, 190, 40);
  border-color: rgb(105, 190, 40);
}
.tooltippopup__btn li button.implement {
  color: rgb(245, 67, 89);
  border-color: rgb(245, 67, 89);
}
.tooltippopup__btn li button:focus {
  outline: none;
}
.tooltippopup__btn li button.tooltippopup__btncompleted {
  opacity: 0.2;
}
.tooltippopup__btn li button.tooltippopup__btncompleted:hover {
  opacity: 1;
}
.tooltippopup__btn li button.tooltippopup__btnactive {
  opacity: 1;
}
.tooltippopup__btn li button:hover {
  position: relative;
  z-index: 9;
}
.tooltippopup__btn li + li {
  margin-left: -1px;
}
.tooltippopup__btn li:first-child button {
  border-radius: 3px 0 0 3px;
}
.tooltippopup__btn li:last-child button {
  border-radius: 0 3px 3px 0;
}
.tooltippopup h4 {
  color: #676a6c;
  margin: 0 0 10px;
  font-size: 16px;
  line-height: 1.2;
}
.tooltippopup p {
  color: #676a6c;
  margin: 0 0 10px;
  font-size: 14px;
  line-height: 1.4;
}
.tooltippopup__close {
  position: absolute;
  top: 10px;
  right: 25px;
  width: 18px;
  height: 18px;
  cursor: pointer;
  transition: all ease 0.3s;
}
.tooltippopup__close:hover {
  transform: rotate(360deg);
}
.tooltippopup__close > div {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transform: rotate(45deg);
}
.tooltippopup__close > div span {
  position: absolute;
  background: #676a6c;
}
.tooltippopup__close > div span:nth-child(1) {
  top: 0;
  left: calc(50% - 1px);
  width: 2px;
  height: 100%;
}
.tooltippopup__close > div span:nth-child(2) {
  top: calc(50% - 1px);
  left: 0;
  width: 100%;
  height: 2px;
}
.tooltippopup__child {
  margin-top: 20px;
}
.tooltippopup__childdata .table-responsive {
  overflow-x: auto;
  margin-bottom: 10px;
}
.tooltippopup__childdata .table-responsive table {
  min-width: 297px;
  border: 1px solid #e7eaec;
}
.tooltippopup__childdata .table-responsive table th,
.tooltippopup__childdata .table-responsive table td {
  border: 1px solid #e7eaec;
  min-width: 120px;
}
.tooltippopup__childdata .table-responsive + * {
  margin-top: 20px;
}
.tooltippopup__childdata--clarify h4 {
  color: rgb(0, 173, 208);
}
.tooltippopup__childdata--ideate h4 {
  color: rgb(255, 121, 0);
}
.tooltippopup__childdata--develop h4 {
  color: rgb(105, 190, 40);
}
.tooltippopup__childdata--implement h4 {
  color: rgb(245, 67, 89);
}
.tooltippopup__childdata h4 {
  font-size: 16px;
  font-weight: 500;
  margin: 0 0 2px;
  font-family: "Museo-700" !important;
  font-weight: normal !important;
}
.tooltippopup__childdata h4 + h5 {
  mask-type: 10px;
}
.tooltippopup__childdata p {
  margin-bottom: 5px;
  line-height: 1.3;
}
.tooltippopup__childdata p:last-child {
  margin-bottom: 0;
}
.tooltippopup__childdata + div {
  margin-top: 17px;
}
.tooltippopup__links {
  padding: 0;
  margin: 0;
}
.tooltippopup__links li {
  list-style: none;
  width: 100%;
}
.tooltippopup__links li a {
  position: relative;
  color: rgb(0, 173, 208);
  transition: all ease 0.3s;
}
.tooltippopup__links li a.ideate {
  color: rgb(255, 121, 0);
  border-color: rgb(255, 121, 0);
}
.tooltippopup__links li a.develop {
  color: rgb(105, 190, 40);
  border-color: rgb(105, 190, 40);
}
.tooltippopup__links li a.implement {
  color: rgb(245, 67, 89);
  border-color: rgb(245, 67, 89);
}
.tooltippopup__links li a:hover {
  opacity: 0.75;
}
.tooltippopup__links li + li {
  margin-top: 4px;
}

.popaccordian__rowhead {
  position: relative;
  cursor: pointer;
  border: 1px solid rgb(0, 173, 208);
  padding: 9px;
  border-radius: 3px;
  display: flex;
  flex-wrap: wrap;
}
.popaccordian__rowhead.ideate {
  color: rgb(255, 121, 0);
  border-color: rgb(255, 121, 0);
}
.popaccordian__rowhead.develop {
  color: rgb(105, 190, 40);
  border-color: rgb(105, 190, 40);
}
.popaccordian__rowhead.implement {
  color: rgb(245, 67, 89);
  border-color: rgb(245, 67, 89);
}
.popaccordian__rowheadarrow {
  position: absolute;
  top: 0;
  left: 0;
}
.popaccordian__rowhead h5 {
  margin: 0;
  position: relative;
  color: rgb(0, 173, 208);
  padding-left: 10px;
  font-family: "Museo-700" !important;
  font-weight: normal !important;
}
.popaccordian__rowhead h5.ideate {
  color: rgb(255, 121, 0);
  border-color: rgb(255, 121, 0);
}
.popaccordian__rowhead h5.develop {
  color: rgb(105, 190, 40);
  border-color: rgb(105, 190, 40);
}
.popaccordian__rowhead h5.implement {
  color: rgb(245, 67, 89);
  border-color: rgb(245, 67, 89);
}
.popaccordian__rowhead h5 i {
  transition: all ease 0.3s;
}
.popaccordian__rowbody {
  border: 1px solid rgb(0, 173, 208);
  border-top: 0;
  display: none;
  border-radius: 0 0 3px 3px;
}
.popaccordian__rowbody.ideate {
  color: rgb(255, 121, 0);
  border-color: rgb(255, 121, 0);
}
.popaccordian__rowbody.develop {
  color: rgb(105, 190, 40);
  border-color: rgb(105, 190, 40);
}
.popaccordian__rowbody.implement {
  color: rgb(245, 67, 89);
  border-color: rgb(245, 67, 89);
}
.popaccordian__rowbodyinner {
  padding: 10px;
}
.popaccordian__rowbodyinner > *:last-child {
  margin-bottom: 0;
}
.popaccordian__rowbodyinner h5 {
  margin: 0 0 10px;
  position: relative;
  color: rgb(0, 173, 208);
  font-family: "Museo-700" !important;
  font-weight: normal !important;
}
.popaccordian__rowbodyinner h5.ideate {
  color: rgb(255, 121, 0);
  border-color: rgb(255, 121, 0);
}
.popaccordian__rowbodyinner h5.develop {
  color: rgb(105, 190, 40);
  border-color: rgb(105, 190, 40);
}
.popaccordian__rowbodyinner h5.implement {
  color: rgb(245, 67, 89);
  border-color: rgb(245, 67, 89);
}
.popaccordian__rowbodyinner ul {
  margin: 0;
  padding: 0;
}
.popaccordian__rowbodyinner ul li {
  list-style: none;
  font-size: 14px;
  line-height: 1.3;
  position: relative;
  padding-left: 10px;
}
.popaccordian__rowbodyinner ul li::before {
  content: "";
  position: absolute;
  top: 7px;
  left: 0;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background-color: #444;
}
.popaccordian__rowbodyinner ul li + li {
  margin-top: 5px;
}
.popaccordian__rowvideo {
  margin-top: 20px;
  padding-bottom: 15px;
}
.popaccordian__rowvideoinner {
  position: relative;
}
.popaccordian__rowvideoinner iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100% !important;
  height: 100% !important;
}
.popaccordian__row + div {
  margin-top: 15px;
}
.popaccordian__row .popaccordian__rowhead {
  align-items: center;
  justify-content: space-between;
}
.popaccordian__row--active .popaccordian__rowhead {
  border-radius: 3px 3px 0 0;
}
.popaccordian__row--active .popaccordian__rowhead h5 i {
  transform: rotate(90deg);
}
.popaccordian__row:first-child .popaccordian__rowbody {
  display: block;
}
.popaccordian__gen .slctrs {
  border-bottom: 1.5px solid #F1F1F2;
}
.popaccordian__gen select {
  width: 100%;
  border: 1px solid #CFDBE2;
  padding: 6px;
  height: 45px;
  border-radius: 4px;
  color: inherit;
}
.popaccordian__gen label {
  display: block;
}
.popaccordian__gen button {
  background-color: #06A6CE;
  border-color: #06A6CE;
}
.popaccordian__gen__aidata {
  min-height: 400px;
  position: relative;
  display: none;
}
.popaccordian__gen__aidata--hyt {
  min-height: auto;
}
.popaccordian__gen__addbtn button {
  background-color: transparent;
  border: 0;
}
.popaccordian__gen__addbtn button:active {
  box-shadow: none;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/app/components/challenges/tooltip-popup/tooltip-popup.component.scss"],"names":[],"mappings":"AAgIA;EACE,eAAA;AC/HF;;ADkIA;EACE,aAAA;EACA,eAAA;AC/HF;;ADkIA;EACE,sBAAA;AC/HF;;ADkIA;EACE,8BAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,aAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;AD6IE;;;;;;EAME,YAAA;EACA,wBA7KO;EA8KP,cA3IiB;EA4IjB,0BAAA;EACA,aAAA;AC1IJ;AD4II;;;;;;EACE,gBAAA;ACrIN;ADyIE;;EAEE,eA5GO;EA6GP,gBA3GO;AC5BX;ADyII;EALF;;IAMI,eA/GY;ECtBhB;AACF;ADwIE;;EAEE,eAlHO;EAmHP,gBAjHO;ACrBX;ADwII;EALF;;IAMI,eArHY;ECfhB;AACF;ADuIE;;EAEE,eAxHO;EAyHP,gBAvHO;ACdX;ADuII;EALF;;IAMI,eA3HY;ECRhB;AACF;ADsIE;;EAEE,eA9HO;EA+HP,gBA7HO;ACPX;ADuIE;;EAEE,eAhIO;EAiIP,gBAhIO;ACLX;ADwIE;;EAEE,eAnIO;EAoIP,gBAnIO;ACHX;AD4IE;EACE,eAAA;EACA,gBAAA;EACA,cAzMqB;EA0MrB,aAAA;EACA,mBAAA;AC1IJ;AD4II;EACE,gBAAA;AC1IN;AD6II;EAXF;IAYI,eAAA;EC1IJ;AACF;AD6IE;;EAEE,UAAA;EACA,SAAA;AC3IJ;AD8IE;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;AC5IJ;;ADgJA;EACE,sBAxNQ;AC2EV;;ADgJA;EACE,iBAlKU;EAmKV,wBAAA;EACA,mBAAA;AC7IF;AD+IE;EALF;IAMI,cAAA;EC5IF;AACF;AD8IE;EACE,iBA1Ka;AC8BjB;AD+IE;EACE,gBApLa;EAqLb,WAAA;AC7IJ;;ADkJE;EACE,kBAAA;AC/IJ;ADkJE;EACE,iBAAA;AChJJ;;ADqJE;EACE,aAAA;AClJJ;;ADsJA;EACE,kBAAA;ACnJF;ADqJE;EACE,mBAAA;ACnJJ;ADuJI;EACE,sBAAA;ACrJN;ADyJE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eA9Ne;ACuEnB;ADyJI;EACE,sBAAA;ACvJN;AD0JI;EAVF;IAWI,eApOoB;EC6ExB;AACF;AD0JE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;ACxJJ;AD0JI;EACE,sBAAA;ACxJN;AD2JI;EACE,WAAA;ACzJN;AD4JI;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BA5VM;ACkMZ;;AD+JA;EACE,mBA1PO;AC8FT;AD8JE;EAHF;IAII,mBAAA;EC3JF;AACF;AD6JE;EACE,mBAAA;AC3JJ;AD8JE;EACE,aArQK;ACyGT;AD8JI;EAHF;IAII,aAAA;EC3JJ;AACF;AD6JI;EACE,aAAA;AC3JN;;ADgKA;EACE,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;AC7JF;AD+JE;EACE,eAAA;AC7JJ;ADgKE;EACE,sCAAA;AC9JJ;ADiKE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,oNAAA;AC/JJ;;AD8KE;EACE,eAAA;EACA,gBAAA;EACA,cA/XqB;EAgYrB,gBAAA;EACA,kBAAA;EACA,kBAAA;AC3KJ;AD6KI;EACE,kBAAA;AC3KN;AD8KI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;AC5KN;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,+BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,mBAAA;EACA,oBAAA;EACA,mCAzbc;EA0bd,WAzZS;EA0ZT,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAhdS;EAidT,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;AC9KF;ADgLE;EACE,2BAAA;EACA,mBAAA;AC9KJ;ADiLE;EACE,yBAzbiB;EA0bjB,WA1aO;AC2PX;ADkLE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;AChLJ;ADmLE;EACE,yBAjckB;EAkclB,cArciB;ACoRrB;ADoLE;EACE,yBAvbS;EAwbT,WA1bO;ACwQX;ADoLI;EACE,6BAAA;AClLN;;ADuLA;EACE;IACE,uBAAA;ECpLF;EDuLA;IACE,yBAAA;ECrLF;AACF;ADwLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,+BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,qBAAA;ACtLF;;ADyLA;EACE,UAAA;ACtLF;ADwLE;EACE,qBAAA;ACtLJ;;AD0LA;EACE,UAAA;ACvLF;;AD2LE;EACE,YAAA;EACA,oCAAA;EAEA,aAAA;EACA,eAAA;EACA,gCAAA;ACzLJ;AD4LM;EACE,mBAAA;AC1LR;AD+LE;EACE,2BAAA;AC7LJ;ADgME;EACE,uBAAA;AC9LJ;ADiME;EACE,mBAAA;AC/LJ;;ADoME;EACE,mBAAA;ACjMJ;ADoME;EACE,yBAAA;AClMJ;ADqME;EACE,sBAAA;ACnMJ;ADsME;EACE,uBAAA;ACpMJ;ADuME;EACE,oBAAA;ACrMJ;;AAtWA;EACI,gBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,MAAA;EACA,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,aAAA;EACA,wCAAA;EA3BA,yBAAA;EA6BA,gBAAA;AA2WJ;AAzWI;EACI,QAAA;AA2WR;AAxWI;EACI,gBAAA;AA0WR;AAvWI;EA3DA,aAAA;EAEA,eAAA;EA2DI,UAAA;EACA,gBAAA;AA6WR;AA3WQ;EACI,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,qBAAA;AA6WZ;AA3WY;EACI,WAAA;EACA,uBDvDA;ECwDA,eAAA;EACA,iBAAA;EDmFd,mCAAA;EACA,8BAAA;EClFc,qBAAA;EACA,YAAA;EACA,SAAA;EACA,kCAAA;EACA,6BAAA;EACA,yBAAA;EAvDZ,gBAAA;AAwaJ;AA9WgB;EACI,uBDnEL;ECoEK,8BDpEL;ACobf;AA9WgB;EACI,wBDtEJ;ECuEI,+BDvEJ;ACubhB;AA9WgB;EACI,uBDzEF;EC0EE,8BD1EF;AC0blB;AA7WgB;EACI,aAAA;AA+WpB;AA5WgB;EACI,YAAA;AA8WpB;AA5WoB;EACI,UAAA;AA8WxB;AA1WgB;EACI,UAAA;AA4WpB;AAzWgB;EACI,kBAAA;EACA,UAAA;AA2WpB;AAvWY;EACI,iBAAA;AAyWhB;AArWgB;EACI,0BAAA;AAuWpB;AAlWgB;EACI,0BAAA;AAoWpB;AA9VI;EACI,cAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AAgWR;AA7VI;EACI,cAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AA+VR;AA5VI;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EAzIJ,yBAAA;AA0eJ;AA9VQ;EAGI,yBAAA;AAgWZ;AA7VQ;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EAGA,wBAAA;AA+VZ;AA7VY;EACI,kBAAA;EACA,mBAAA;AA+VhB;AA7VgB;EACI,MAAA;EACA,qBAAA;EACA,UAAA;EACA,YAAA;AA+VpB;AA5VgB;EACI,oBAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;AA8VpB;AAxVI;EACI,gBAAA;AA0VR;AAvVY;EACI,gBAAA;EACA,mBAAA;AAyVhB;AAvVgB;EACI,gBAAA;EACA,yBAAA;AAyVpB;AAvVoB;;EAEI,yBAAA;EACA,gBAAA;AAyVxB;AArVgB;EACI,gBAAA;AAuVpB;AAlVgB;EACI,uBD9MJ;ACkiBhB;AA/UgB;EACI,uBDnNL;ACoiBf;AA5UgB;EACI,wBDxNJ;ACsiBhB;AAzUgB;EACI,uBD7NF;ACwiBlB;AAvUY;EACI,eAAA;EACA,gBAAA;EACA,eAAA;ED3Fd,mCAAA;EACA,8BAAA;ACqaF;AAxUgB;EACI,eAAA;AA0UpB;AAtUY;EACI,kBAAA;EACA,gBAAA;AAwUhB;AAtUgB;EACI,gBAAA;AAwUpB;AApUY;EACI,gBAAA;AAsUhB;AAjUI;EACI,UAAA;EACA,SAAA;AAmUR;AAjUQ;EACI,gBAAA;EACA,WAAA;AAmUZ;AAjUY;EACI,kBAAA;EACA,uBDxQA;ECGZ,yBAAA;AA2kBJ;AAnUgB;EACI,uBD3QL;EC4QK,8BD5QL;ACilBf;AAnUgB;EACI,wBD9QJ;EC+QI,+BD/QJ;AColBhB;AAnUgB;EACI,uBDjRF;ECkRE,8BDlRF;ACulBlB;AAhUgB;EACI,aAAA;AAkUpB;AA9TY;EACI,eAAA;AAgUhB;;AAtTQ;EACI,kBAAA;EACA,eAAA;EACA,kCAAA;EACA,YAAA;EACA,kBAAA;EAhUR,aAAA;EAEA,eAAA;AA4nBJ;AA3TY;EACI,uBDlTD;ECmTC,8BDnTD;ACgnBf;AA3TY;EACI,wBDrTA;ECsTA,+BDtTA;ACmnBhB;AA3TY;EACI,uBDxTE;ECyTF,8BDzTE;ACsnBlB;AA1TY;EACI,kBAAA;EACA,MAAA;EACA,OAAA;AA4ThB;AAzTY;EACI,SAAA;EACA,kBAAA;EACA,uBDxUA;ECyUA,kBAAA;ED7Ld,mCAAA;EACA,8BAAA;ACyfF;AAzTgB;EACI,uBD7UL;EC8UK,8BD9UL;ACyoBf;AAzTgB;EACI,wBDhVJ;ECiVI,+BDjVJ;AC4oBhB;AAzTgB;EACI,uBDnVF;ECoVE,8BDpVF;AC+oBlB;AAxTgB;EAvVZ,yBAAA;AAopBJ;AAvTQ;EACI,kCAAA;EACA,aAAA;EACA,aAAA;EACA,0BAAA;AAyTZ;AAvTY;EACI,uBDtWD;ECuWC,8BDvWD;ACgqBf;AAvTY;EACI,wBDzWA;EC0WA,+BD1WA;ACmqBhB;AAvTY;EACI,uBD5WE;EC6WF,8BD7WE;ACsqBlB;AAtTY;EACI,aAAA;AAwThB;AAtTgB;EACI,gBAAA;AAwTpB;AArTgB;EACI,gBAAA;EACA,kBAAA;EACA,uBD7XJ;EA4Id,mCAAA;EACA,8BAAA;ACyiBF;AAtToB;EACA,uBDhYL;ECiYK,8BDjYL;ACyrBf;AAtTgB;EACI,wBDnYJ;ECoYI,+BDpYJ;AC4rBhB;AAtTgB;EACI,uBDtYF;ECuYE,8BDvYF;AC+rBlB;AApTgB;EACI,SAAA;EACA,UAAA;AAsTpB;AApToB;EACI,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;AAsTxB;AApTwB;EACI,WAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;AAsT5B;AAnTwB;EACI,eAAA;AAqT5B;AA9SQ;EACI,gBAAA;EACA,oBAAA;AAgTZ;AA9SY;EACI,kBAAA;AAgThB;AA7SgB;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,sBAAA;EACA,uBAAA;AA+SpB;AA1SQ;EACI,gBAAA;AA4SZ;AAzSQ;EACI,mBAAA;EACA,8BAAA;AA2SZ;AAvSY;EACI,0BAAA;AAyShB;AAvSgB;EA5bZ,wBAAA;AAwuBJ;AAnSY;EACI,cAAA;AAqShB;AA/RQ;EACI,kCAAA;AAiSZ;AA9RQ;EACI,WAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;AAgSZ;AA7RQ;EACI,cAAA;AA+RZ;AA5RQ;EACI,yBAAA;EACA,qBAAA;AA8RZ;AA3RQ;EACI,iBAAA;EACA,kBAAA;EACA,aAAA;AA6RZ;AA3RY;EACI,gBAAA;AA6RhB;AAvRY;EACI,6BAAA;EACA,SAAA;AAyRhB;AAvRgB;EACI,gBAAA;AAyRpB","sourcesContent":["// Font\n$font-stack: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n$muso-100: \"Museo-100\";\n$muso-300: \"Museo-300\";\n$muso-300-i: \"Museo-300Italic\";\n$muso-500: \"Museo-regular\";\n$muso-700: \"Museo-700\";\n$muso-700-i: \"Museo-700Italic\";\n$muso-sans: \"MuseoSans-300\";\n$car-font: \"Marydale\";\n$car-big-font: \"Bangers\", cursive;\n$font-museo: \"Conv_museo-500-webfont\";\n$font-helvetica: \"Helvetica\", \"open sans\";\n$MuseoSansCondensed-300: \"MuseoSansCondensed-300\";\n\n$fwBold: 700;\n\n//Foursight\n// $clarify-color: #06A6CE;\n// $ideate-color: #FF8300;\n// $develop-color: #7BBC43;\n// $implement-color: #FF485C;\n$clarify-color: rgba(0, 173, 208, 1);\n$ideate-color: rgba(255, 121, 0, 1);\n$develop-color: rgba(105, 190, 40, 1);\n$implement-color: rgba(245, 67, 89, 1);\n$low-clarify-color: rgba(0, 173, 208, 1);\n$low-ideate-color: rgba(255, 121, 0, 1);\n$low-develop-color: rgba(105, 190, 40, 1);\n$low-implement-color: rgba(245, 67, 89, 1);\n$profile-connector-color: #656668;\n// Profile Neutral color\n$integrator-color: #e3e3e3;\n// Team Report\n$report-integrator: #a7a7a7;\n// Body text color in reports\n$body-content-color: #676a6c;\n// Learner Map\n$gray-lm: rgba(0, 0, 0, 0.2);\n$border-color: #aaa;\n\n$color-neutral-dark: #6d6e71;\n$color-neutral-dark-500: #6a6a6a;\n$color-neutral-mid: #ccc;\n$color-neutral-light: #f1f1f2;\n$color-neutral-mid-old: #9e9e97;\n$color-dark-green: #4cae4c;\n$color-light-grey: #d9d9d9;\n$color-red: #ff485c;\n\n$color-grey-1: #e7eaec;\n\n$clrGray1: #f6f6f6;\n\n$clrDarkGray1: #ddd;\n\n$clrGrey: #eee;\n$clrWhite: #fff;\n$clrBlack: #000;\n$clrWarning: #f8ac59;\n\n$assets: \"https://assets.foursightonline.com/app\";\n$adminUpload: \"https://assets.foursightonline.com/admin-uploads/docs/\";\n\n$separator: \"\\//\";\n\n$active-class: #017ebc;\n\n// anchor Tag\n$anchor-color: #337ab7;\n\n//Sidebar\n$color-light-type: #fff;\n// submenu background\n$fs-dark-grey: #464646;\n// Hover\n$fs-active-light: #5f5f63;\n$fs-sidenav-bg: #333333;\n$fs-sidenav-hov-bg: #3e3e3f;\n$fs-green: #69be28;\n\n$clrInputAccent: #639935;\n\n$fn-fs-h1: 44px;\n$fn-fs-h1-mobile: 38px;\n$fn-lh-h1: 1.1;\n\n$fn-fs-h2: 38px;\n$fn-fs-h2-mobile: 32px;\n$fn-lh-h2: 1.2;\n\n$fn-fs-h3: 32px;\n$fn-fs-h3-mobile: 24px;\n$fn-lh-h3: 1.2;\n\n$fn-fs-h4: 24px;\n$fn-fs-h4-mobile: 20px;\n$fn-lh-h4: 1.2;\n\n$fn-fs-h5: 18px;\n$fn-lh-h5: 1.2;\n\n$fn-fs-h6: 16px;\n$fn-lh-h6: 1.3;\n\n$fn-title-subtext: 22px;\n$fn-title-subtext-mobile: 18px;\n\n$pageWidth: 1080px;\n$pageWidthSmall: 820px;\n$pageWidthFluid: 1200px;\n\n$secPad: 60px;\n\n$pageWidth: 1080px;\n$pageWidthFluid: 1200px;\n\n$desktop: \"only screen and (max-width: 1600px)\";\n$mac: \"only screen and (max-width: 1350px)\";\n$pc-up: \"only screen and (min-width: 1200px)\";\n$pc: \"only screen and (max-width: 1199px)\";\n$tablet-up: \"only screen and (min-width: 992px)\";\n$tablet: \"only screen and (max-width: 991px)\";\n$mobile-up: \"only screen and (min-width: 768px)\";\n$mobile: \"only screen and (max-width: 767px)\";\n$xl: \"only screen and (max-width: 1440px)\";\n$xl-up: \"only screen and (min-width: 1440px)\";\n\nimg {\n  max-width: 100%;\n}\n\n.flex {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.dir-col {\n  flex-direction: column;\n}\n\n.dir-col-rev {\n  flex-direction: column-reverse;\n}\n\n.mh-full {\n  min-height: 100%;\n}\n\n.mt-auto {\n  margin-top: auto;\n}\n\n.bt-0 {\n  border-top: 0;\n}\n\n.bb-0 {\n  border-bottom: 0;\n}\n\n@mixin headingfont() {\n  font-family: $muso-700 !important;\n  font-weight: normal !important;\n}\n\n@mixin contentfont() {\n  font-family: $muso-300 !important;\n  font-weight: normal !important;\n}\n\n.fn-body {\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    --hGap: 10px;\n    font-family: $muso-700;\n    color: $color-neutral-dark;\n    margin-bottom: var(--hGap);\n    margin-top: 0;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  h1,\n  .h1-text {\n    font-size: $fn-fs-h1;\n    line-height: $fn-lh-h1;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h1-mobile;\n    }\n  }\n\n  h2,\n  .h2-text {\n    font-size: $fn-fs-h2;\n    line-height: $fn-lh-h2;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h2-mobile;\n    }\n  }\n\n  h3,\n  .h3-text {\n    font-size: $fn-fs-h3;\n    line-height: $fn-lh-h3;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h3-mobile;\n    }\n  }\n\n  h4,\n  .h4-text {\n    font-size: $fn-fs-h4;\n    line-height: $fn-lh-h4;\n  }\n\n  h5,\n  .h5-text {\n    font-size: $fn-fs-h5;\n    line-height: $fn-lh-h5;\n  }\n\n  h6,\n  .h6-text {\n    font-size: $fn-fs-h6;\n    line-height: $fn-lh-h6;\n  }\n\n  $fn-title-subtext: 22px;\n  $fn-title-subtext-mobile: 18px;\n\n  p {\n    font-size: 18px;\n    line-height: 1.6;\n    color: $color-neutral-dark-500;\n    margin-top: 0;\n    margin-bottom: 10px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    @media #{$mobile} {\n      font-size: 16px;\n    }\n  }\n\n  ul,\n  ol {\n    padding: 0;\n    margin: 0;\n  }\n\n  sup {\n    font-size: 0.7em;\n    position: relative;\n    top: 5px;\n    display: inline-block;\n    vertical-align: top;\n  }\n}\n\n.bg-grey {\n  background-color: $clrGrey;\n}\n\n.fn-container {\n  max-width: $pageWidth;\n  width: calc(100% - 30px);\n  margin-inline: auto;\n\n  @media #{$tablet-up} {\n    margin-left: 0;\n  }\n\n  &--fluid {\n    max-width: $pageWidthFluid;\n  }\n\n  &--small {\n    max-width: $pageWidthSmall;\n    width: 100%;\n  }\n}\n\n.text {\n  &-center {\n    text-align: center;\n  }\n\n  &-right {\n    text-align: right;\n  }\n}\n\n.d {\n  &-none {\n    display: none;\n  }\n}\n\n.section-title {\n  text-align: center;\n\n  &:not(:last-child) {\n    margin-bottom: calc($secPad - 20px);\n  }\n\n  h2 {\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n  }\n\n  p {\n    max-width: 900px;\n    width: 100%;\n    margin-inline: auto;\n    font-size: $fn-title-subtext;\n\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n\n    @media #{$mobile} {\n      font-size: $fn-title-subtext-mobile;\n    }\n  }\n\n  .section-title__linkcontainer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n\n    &:not(:last-child) {\n      margin-block-end: 20px;\n    }\n\n    & > * {\n      margin: 5px;\n    }\n\n    .fn-btn {\n      padding-block: 6px;\n      padding-inline: 13px;\n      font-size: 12px;\n      font-family: $muso-sans;\n    }\n  }\n}\n\n.section-padding {\n  padding-block: $secPad;\n\n  @media #{$mobile} {\n    padding-block: ($secPad - 20px);\n  }\n\n  &-small {\n    padding-block: calc($secPad / 2);\n  }\n\n  &-all {\n    padding: $secPad;\n\n    @media #{$mobile} {\n      padding: calc($secPad / 2);\n    }\n\n    &-small {\n      padding: calc($secPad / 2);\n    }\n  }\n}\n\n.headline {\n  --lineSize: 10px;\n  width: fit-content;\n  padding-block-end: calc(10px + var(--lineSize));\n  margin-inline: auto;\n  position: relative;\n\n  &--small-border {\n    --lineSize: 6px;\n  }\n\n  &:not(:last-child) {\n    margin-bottom: calc(var(--hGap) * 2.5);\n  }\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: var(--lineSize);\n    background: linear-gradient(\n      90deg,\n      $clarify-color 0%,\n      $clarify-color 25%,\n      $ideate-color 25%,\n      $ideate-color 50%,\n      $develop-color 50%,\n      $develop-color 75%,\n      $implement-color 75%,\n      $implement-color 100%\n    );\n  }\n}\n\n.custom-list {\n  li {\n    font-size: 18px;\n    line-height: 1.4;\n    color: $color-neutral-dark-500;\n    list-style: none;\n    position: relative;\n    padding-left: 15px;\n\n    &:not(:last-child) {\n      margin-bottom: 4px;\n    }\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      top: 10px;\n      left: 0;\n      width: 3px;\n      height: 3px;\n      background-color: var(--clrProfile);\n    }\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.fn-btn {\n  padding-block: 20px;\n  padding-inline: 28px;\n  background-color: $develop-color;\n  color: $clrWhite;\n  font-size: 18px;\n  line-height: 1.2;\n  display: inline-block;\n  font-family: $muso-700;\n  text-decoration: none;\n  word-break: break-all;\n  text-align: center;\n  transition: background-color 0.3s;\n\n  &:focus {\n    outline: 1px dashed $color-neutral-dark-500;\n    outline-offset: 4px;\n  }\n\n  &:hover {\n    background-color: $color-neutral-dark;\n    color: $clrWhite;\n  }\n\n  &--sm {\n    font-size: 14px;\n    padding-block: 10px;\n    padding-inline: 20px;\n  }\n\n  &--grey {\n    background-color: $color-neutral-light;\n    color: $color-neutral-dark;\n  }\n\n  &--ongoing {\n    background-color: $clrWarning;\n    color: $clrWhite;\n\n    i {\n      animation: spin 0.3s infinite;\n    }\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.w-4 {\n  width: calc(100% / 3);\n}\n\n.w-3 {\n  width: calc(100% / 4);\n\n  &--wd {\n    width: calc(100% / 3);\n  }\n}\n\n.w-6 {\n  width: calc(100% / 2);\n}\n\n.fn {\n  &-row {\n    --rGap: 15px;\n    --rGap-minus: calc(-1 * var(--rGap));\n\n    display: flex;\n    flex-wrap: wrap;\n    margin-inline: var(--rGap-minus);\n\n    &--col-gap-exist {\n      .fn-col {\n        margin-bottom: calc($secPad / 2);\n      }\n    }\n  }\n\n  &-col {\n    padding-inline: var(--rGap);\n  }\n\n  &-justify-center {\n    justify-content: center;\n  }\n\n  &-items-center {\n    align-items: center;\n  }\n}\n\n.m {\n  &x-auto {\n    margin-inline: auto;\n  }\n\n  &l-auto {\n    margin-inline-start: auto;\n  }\n\n  &l-0 {\n    margin-inline-start: 0;\n  }\n\n  &r-auto {\n    margin-inline-end: auto;\n  }\n\n  &r-0 {\n    margin-inline-end: 0;\n  }\n}\n","@import './../../../../assets/styles/variables';\n\n@mixin fflex() {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n    flex-wrap: wrap;\n}\n\n@mixin fflex-jcc() {\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n}\n\n@mixin fflex-aic() {\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n}\n\n@mixin transition-slow() {\n    -webkit-transition: all ease 0.3s;\n    -o-transition: all ease 0.3s;\n    transition: all ease 0.3s;\n}\n\n@mixin appearance-none() {\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n}\n\n@mixin transRotate ($rotate) {\n    -webkit-transform: rotate($rotate);\n    -ms-transform: rotate($rotate);\n    transform: rotate($rotate);\n}\n\n\n.tooltippopup {\n    max-width: 360px;\n    width: 100%;\n    height: 100%;\n    background: #fff;\n    position: fixed;\n    top: 0;\n    right: -400px;\n    padding: 45px 24px 24px;\n    text-align: left;\n    z-index: 9999;\n    box-shadow: 0 0 20px rgba(0, 0, 0, 0.05);\n    @include transition-slow();\n    overflow-y: auto;\n\n    &--active {\n        right: 0;\n    }\n\n    &--videoexist {\n        max-width: 735px;\n    }\n\n    &__btn {\n        @include fflex();\n        padding: 0;\n        margin: 0 0 10px;\n\n        li {\n            list-style: none;\n            text-align: center;\n            cursor: pointer;\n            width: calc(100% / 3);\n\n            button {\n                width: 100%;\n                color: $clarify-color;\n                font-size: 12px;\n                padding: 6px 16px;\n                @include headingfont();\n                display: inline-block;\n                height: 100%;\n                border: 0;\n                border: 1px solid $clarify-color;\n                background-color: transparent;\n                transition: all ease 0.3s;\n                @include appearance-none();\n\n                &.ideate{\n                    color: $ideate-color;\n                    border-color: $ideate-color;\n                }\n                &.develop{\n                    color: $develop-color;\n                    border-color:  $develop-color;\n                }\n                &.implement{\n                    color: $implement-color;\n                    border-color:$implement-color;\n                }\n\n                &:focus {\n                    outline: none;\n                }\n\n                &.tooltippopup__btncompleted {\n                    opacity: 0.2;\n\n                    &:hover {\n                        opacity: 1;\n                    }\n                }\n\n                &.tooltippopup__btnactive {\n                    opacity: 1;\n                }\n\n                &:hover {\n                    position: relative;\n                    z-index: 9;\n                }\n            }\n\n            &+li {\n                margin-left: -1px;\n            }\n\n            &:first-child {\n                button {\n                    border-radius: 3px 0 0 3px\n                }\n            }\n\n            &:last-child {\n                button {\n                    border-radius: 0 3px 3px 0;\n                }\n            }\n        }\n    }\n\n    h4 {\n        color: #676a6c;\n        margin: 0 0 10px;\n        font-size: 16px;\n        line-height: 1.2;\n    }\n\n    p {\n        color: #676a6c;\n        margin: 0 0 10px;\n        font-size: 14px;\n        line-height: 1.4;\n    }\n\n    &__close {\n        position: absolute;\n        top: 10px;\n        right: 25px;\n        width: 18px;\n        height: 18px;\n        cursor: pointer;\n        @include transition-slow();\n\n        &:hover {\n            -webkit-transform: rotate(360deg);\n            -ms-transform: rotate(360deg);\n            transform: rotate(360deg);\n        }\n\n        &>div {\n            position: absolute;\n            top: 0;\n            left: 0;\n            width: 100%;\n            height: 100%;\n            -webkit-transform: rotate(45deg);\n            -ms-transform: rotate(45deg);\n            transform: rotate(45deg);\n\n            span {\n                position: absolute;\n                background: #676a6c;\n\n                &:nth-child(1) {\n                    top: 0;\n                    left: calc(50% - 1px);\n                    width: 2px;\n                    height: 100%;\n                }\n\n                &:nth-child(2) {\n                    top: calc(50% - 1px);\n                    left: 0;\n                    width: 100%;\n                    height: 2px;\n                }\n            }\n        }\n    }\n\n    &__child {\n        margin-top: 20px;\n\n        &data {\n            .table-responsive {\n                overflow-x: auto;\n                margin-bottom: 10px;\n\n                table {\n                    min-width: 297px;\n                    border: 1px solid #e7eaec;\n\n                    th,\n                    td {\n                        border: 1px solid #e7eaec;\n                        min-width: 120px;\n                    }\n                }\n\n                &+* {\n                    margin-top: 20px;\n                }\n            }\n\n            &--clarify {\n                h4 {\n                    color: $clarify-color;\n                }\n            }\n\n            &--ideate {\n                h4 {\n                    color: $ideate-color;\n                }\n            }\n\n            &--develop {\n                h4 {\n                    color: $develop-color;\n                }\n            }\n\n            &--implement {\n                h4 {\n                    color: $implement-color;\n                }\n            }\n\n            h4 {\n                font-size: 16px;\n                font-weight: 500;\n                margin: 0 0 2px;\n                @include headingfont();\n\n                &+h5 {\n                    mask-type: 10px;\n                }\n            }\n\n            p {\n                margin-bottom: 5px;\n                line-height: 1.3;\n\n                &:last-child {\n                    margin-bottom: 0;\n                }\n            }\n\n            &+div {\n                margin-top: 17px;\n            }\n        }\n    }\n\n    &__links {\n        padding: 0;\n        margin: 0;\n\n        li {\n            list-style: none;\n            width: 100%;\n\n            a {\n                position: relative;\n                color: $clarify-color;\n                @include transition-slow();\n\n                &.ideate{\n                    color: $ideate-color;\n                    border-color: $ideate-color;\n                }\n                &.develop{\n                    color: $develop-color;\n                    border-color: $develop-color;\n                }\n                &.implement{\n                    color: $implement-color;\n                    border-color: $implement-color;\n                }\n\n                &::before {}\n\n                &:hover {\n                    opacity: 0.75;\n                }\n            }\n\n            &+li {\n                margin-top: 4px;\n\n            }\n        }\n    }\n}\n\n\n.popaccordian {\n    &__row {\n        &head {\n            position: relative;\n            cursor: pointer;\n            border: 1px solid $clarify-color;\n            padding: 9px;\n            border-radius: 3px;\n            @include fflex();\n\n            &.ideate{\n                color: $ideate-color;\n                border-color: $ideate-color;\n            }\n            &.develop{\n                color: $develop-color;\n                border-color: $develop-color;\n            }\n            &.implement{\n                color: $implement-color;\n                border-color: $implement-color;\n            }\n\n            &arrow {\n                position: absolute;\n                top: 0;\n                left: 0;\n            }\n\n            h5 {\n                margin: 0;\n                position: relative;\n                color: $clarify-color;\n                padding-left: 10px;\n                @include headingfont();\n\n\n                &.ideate{\n                    color: $ideate-color;\n                    border-color: $ideate-color;\n                }\n                &.develop{\n                    color: $develop-color;\n                    border-color: $develop-color;\n                }\n                &.implement{\n                    color: $implement-color;\n                    border-color: $implement-color;\n                }\n\n                i {\n                    @include transition-slow();\n                }\n            }\n        }\n\n        &body {\n            border: 1px solid $clarify-color;\n            border-top: 0;\n            display: none;\n            border-radius: 0 0 3px 3px;\n\n            &.ideate{\n                color: $ideate-color;\n                border-color: $ideate-color;\n            }\n            &.develop{\n                color: $develop-color;\n                border-color: $develop-color;\n            }\n            &.implement{\n                color: $implement-color;\n                border-color: $implement-color;\n            }\n\n            &inner {\n                padding: 10px;\n\n                &>*:last-child {\n                    margin-bottom: 0;\n                }\n\n                h5 {\n                    margin: 0 0 10px;\n                    position: relative;\n                    color: $clarify-color;\n                    @include headingfont();\n\n                    &.ideate{\n                    color: $ideate-color;\n                    border-color: $ideate-color;\n                }\n                &.develop{\n                    color: $develop-color;\n                    border-color: $develop-color;\n                }\n                &.implement{\n                    color: $implement-color;\n                    border-color: $implement-color;\n                }\n                }\n\n                ul {\n                    margin: 0;\n                    padding: 0;\n\n                    li {\n                        list-style: none;\n                        font-size: 14px;\n                        line-height: 1.3;\n                        position: relative;\n                        padding-left: 10px;\n\n                        &::before {\n                            content: \"\";\n                            position: absolute;\n                            top: 7px;\n                            left: 0;\n                            width: 5px;\n                            height: 5px;\n                            border-radius: 50%;\n                            background-color: #444;\n                        }\n\n                        &+li {\n                            margin-top: 5px;\n                        }\n                    }\n                }\n            }\n        }\n\n        &video {\n            margin-top: 20px;\n            padding-bottom: 15px;\n\n            &inner {\n                position: relative;\n                // padding-bottom: 56.25%;\n\n                iframe {\n                    position: absolute;\n                    top: 0;\n                    left: 0;\n                    width: 100% !important;\n                    height: 100% !important;\n                }\n            }\n        }\n\n        &+div {\n            margin-top: 15px;\n        }\n\n        .popaccordian__rowhead {\n            align-items: center;\n            justify-content: space-between;\n        }\n\n        &--active {\n            .popaccordian__rowhead {\n                border-radius: 3px 3px 0 0;\n\n                h5 i {\n                    @include transRotate (90deg);\n                }\n\n\n            }\n        }\n\n        &:first-child {\n            .popaccordian__rowbody {\n                display: block;\n            }\n        }\n    }\n\n    &__gen {\n        .slctrs {\n            border-bottom: 1.5px solid #F1F1F2;\n        }\n\n        select {\n            width: 100%;\n            border: 1px solid #CFDBE2;\n            padding: 6px;\n            height: 45px;\n            border-radius: 4px;\n            color: inherit;\n        }\n\n        label {\n            display: block;\n        }\n\n        button {\n            background-color: #06A6CE;\n            border-color: #06A6CE;\n        }\n\n        &__aidata {\n            min-height: 400px;\n            position: relative;\n            display: none;\n\n            &--hyt {\n                min-height: auto;\n            }\n        }\n\n        &__addbtn {\n\n            button {\n                background-color: transparent;\n                border: 0;\n\n                &:active {\n                    box-shadow: none;\n                }\n            }\n        }\n    }\n\n\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
